import React, { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { toast } from "react-toastify";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import "../../../styles/docs/toggle-switch.css";
import {
  fetchAllLeadsData,
  fetchLeadsStatsData,
} from "../../../redux/reducers/apiSlice";
import LMSStatCards from "./lms-v2-cards/LMSStatCards";
import LMSTabs from "./lms-v2-tabs/LMSTabs";
import CmnFilters from "../common/CmnFilters";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AddLeadForm from "../AddLeadForm";
import LeadJourney from "./lead-journey/LeadJourney";
import LeadEditForm from "../LeadEditForm";
import FollowInfoFormV1 from "../followup/FollowInfoFormV1";
import AssignForm from "../raw-leads/AssignForm";
import { isDev } from "../../common-data/Commons";
import { isBroadcastCreateAllowedEmail } from "../../common-data/Accessibles";
import CommonBroadForm from "../../common-components/broadcast-template/CommonBroadForm";
import SelectExportables from "../../common-components/SelectExportables";
import { leadExportableData } from "../../pt-trials/common/SharedDatas";
import { fetchExportApiData } from "../../../redux/reducers/commonApiSlice";
import { exportLead } from "../../../data/ApiEndpoints";
import LMSPMLink from "./lms-payment-links/LMSPMLink";
import ClickToCall from "./lms-payment-links/ClickToCall";
import CallDetail from "../call-detail/CallDetail";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const LMSStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const tableRef = useRef(null);
  // const mobileTableRef = useRef(null);
  const tabsRef = useRef(null);

  // const { allLeads, leadValuesConverted, leadValuesConvertedLoading } =
  //   useSelector((state) => state.api);
  const { exportData, exportLoading } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const isBroadcastCreateAllowed =
    isDev || isBroadcastCreateAllowedEmail(userInfoData?.email);

  const [showFilters, setShowFilters] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      isGym || (!isAdmin && !isMarketing && !isManagerRole)
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedGyms: [],
    selAddedby: "",
    selAssignee:
      !isAdmin && !isMarketing && !isManagerRole
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selectedAssigneeStatus: "",
    selLeadStatus: "",
    selCustomerIntent: "",
    selFollowupStatus: "",
    selLeadSource: "",
    selUTMSource: "",
    selectedVendor: "",
    selCard: "",
    setPlan: "",
    selFollowupTime: [],
    selIsRaw: "",
    selLeadFrom: "",
    selFollowupStage: "",
    selOperatorValue: "",
    selConvertedIn: [],
    clickedCard: "",
    selectedWhatsappVerification: "",
    selectedLeadStage: "",
    searchString: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadFollowupDateFrom: "",
    leadFollowupDateTo: "",
    leadClosureDateFrom: "",
    leadClosureDateTo: "",
    leadConvertedDateFrom: "",
    leadConvertedDateTo: "",
    rawLeadAddDateFrom: "",
    rawLeadAddDateTo: "",
    isToggledValue: false,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    filter_type: allFilters.clickedCard
      ? allFilters.clickedCard
      : activeTab === 1
      ? "todays_follow_ups"
      : activeTab === 2
      ? "missed_followups"
      : "",
    gym_id: allFilters.selectedGym?.value || "",
    assigned_to: allFilters.selAssignee?.value || "",
    assignee_deleted: allFilters.selectedAssigneeStatus?.value || "",
    added_by: allFilters.selAddedby?.value || "",
    lead_status: allFilters.selLeadStatus?.value || "",
    follow_up_status: allFilters.selFollowupStatus?.value || "",
    source_name: allFilters.selLeadSource?.value || "",
    utm_source: allFilters.selUTMSource?.value || "",
    btl_vendor_id: allFilters.selectedVendor?.value || "",
    lead_type: allFilters.selCard?.value || "",
    intent_id: allFilters.selCustomerIntent?.value || "",
    plan_type: allFilters.setPlan?.value || "",
    is_raw_lead: allFilters.selIsRaw?.value || "",
    wap_image: allFilters.selectedWhatsappVerification?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    follow_up_date_from: allFilters.leadFollowupDateFrom || "",
    follow_up_date_to: allFilters.leadFollowupDateTo || "",
    expected_closure_date_from: allFilters.leadClosureDateFrom || "",
    expected_closure_date_to: allFilters.leadClosureDateTo || "",
    rawlead_start_date: allFilters.rawLeadAddDateFrom || "",
    rawlead_end_date: allFilters.rawLeadAddDateTo || "",
    operator_value: allFilters.selOperatorValue?.value || "",
    mem_lead_stage: allFilters.selectedLeadStage?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: null,
    selectedRows: [],
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [isFilterSegmentShown, setIsFilterSegmentShown] = useState(true);
  const [csvData, setCsvData] = useState();

  const isBroadcastMode = modValues.modName === "broadcast_data";

  const onCloseModal = () => {
    setModValues(iniModValues);
    setIsFilterSegmentShown(true);
    setCsvData();
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickExport = (filters) => {
    if (filters.is_export) {
      getExportedData(filters);
    } else {
      toast.error("IS Export Not Found!");
    }
  };

  function getExportedData(filters) {
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: exportLead,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const handleStatCardClick = (filterType, cardKey) => {
    setAllFilters((prev) => ({
      ...iniAllFilter,
      clickedCard: prev.clickedCard === filterType ? "" : filterType,
    }));
    setIsPage(0);
    setTimeout(() => {
      if (tabsRef.current) {
        tabsRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getLeadStats(filters) {
    const filtersToSend = {
      gym_id: filters.gym_id,
      assigned_to: filters.assigned_to,
      added_by: filters.added_by,
      assignee_deleted: filters.assignee_deleted,
    };

    dispatch(
      fetchLeadsStatsData({
        filters: filtersToSend,
        token: userInfoData?.token,
      })
    );
  }

  function getAllLeads(filters) {
    dispatch(
      fetchAllLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getComineReload() {
    getAllLeads(filters);
    getLeadStats(filters);
  }

  useEffect(() => {
    getAllLeads(filters);
  }, [filters]);

  useEffect(() => {
    getLeadStats(filters);
  }, [
    activeTab,
    allFilters.clickedCard,
    allFilters.selectedGym,
    allFilters.selAssignee,
    allFilters.selectedAssigneeStatus,
    allFilters.selAddedby,
    allFilters.selLeadStatus,
    allFilters.selFollowupStatus,
    allFilters.selLeadSource,
    allFilters.selUTMSource,
    allFilters.selectedVendor,
    allFilters.selCard,
    allFilters.setPlan,
    allFilters.selIsRaw,
    allFilters.selectedWhatsappVerification,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadFollowupDateFrom,
    allFilters.leadFollowupDateTo,
    allFilters.leadClosureDateFrom,
    allFilters.leadClosureDateTo,
    allFilters.rawLeadAddDateFrom,
    allFilters.rawLeadAddDateTo,
    allFilters.selOperatorValue,
    allFilters.selectedLeadStage,
    allFilters.selCustomerIntent,
  ]);

  useEffect(() => {
    const extractGyms = (arr) => {
      let gyms = [];

      arr?.length > 0 &&
        arr.forEach((item) => {
          const itemValue = item.value;
          gyms.push(itemValue);
        });

      return {
        gyms: gyms.join(", "),
      };
    };

    const shouldUseMultipleGyms = isBroadcastMode;
    const { gyms } = shouldUseMultipleGyms
      ? extractGyms(allFilters.selectedGyms)
      : { gyms: "" };

    const gymId = shouldUseMultipleGyms
      ? gyms || allFilters.selectedGym?.value || ""
      : allFilters.selectedGym?.value || "";

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      filter_type: allFilters.clickedCard
        ? allFilters.clickedCard
        : activeTab === 1
        ? "todays_follow_ups"
        : activeTab === 2
        ? "missed_followups"
        : "",
      // gym_id: allFilters.selectedGym?.value || "",
      gym_id: gymId,
      assigned_to: allFilters.selAssignee?.value || "",
      assignee_deleted: allFilters.selectedAssigneeStatus?.value || "",
      added_by: allFilters.selAddedby?.value || "",
      lead_status: allFilters.selLeadStatus?.value || "",
      follow_up_status: allFilters.selFollowupStatus?.value || "",
      source_name: allFilters.selLeadSource?.value || "",
      utm_source: allFilters.selUTMSource?.value || "",
      btl_vendor_id: allFilters.selectedVendor?.value || "",
      lead_type: allFilters.selCard?.value || "",
      intent_id: allFilters.selCustomerIntent?.value || "",
      plan_type: allFilters.setPlan?.value || "",
      is_raw_lead: allFilters.selIsRaw?.value || "",
      wap_image: allFilters.selectedWhatsappVerification?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      follow_up_date_from: allFilters.leadFollowupDateFrom || "",
      follow_up_date_to: allFilters.leadFollowupDateTo || "",
      expected_closure_date_from: allFilters.leadClosureDateFrom || "",
      expected_closure_date_to: allFilters.leadClosureDateTo || "",
      rawlead_start_date: allFilters.rawLeadAddDateFrom || "",
      rawlead_end_date: allFilters.rawLeadAddDateTo || "",
      operator_value: allFilters.selOperatorValue?.value || "",
      mem_lead_stage: allFilters.selectedLeadStage?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    activeTab,
    allFilters.clickedCard,
    allFilters.selectedGym,
    allFilters.selectedGyms,
    allFilters.selAssignee,
    allFilters.selectedAssigneeStatus,
    allFilters.selAddedby,
    allFilters.selLeadStatus,
    allFilters.selFollowupStatus,
    allFilters.selLeadSource,
    allFilters.selUTMSource,
    allFilters.selectedVendor,
    allFilters.selCard,
    allFilters.setPlan,
    allFilters.selIsRaw,
    allFilters.selectedWhatsappVerification,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadFollowupDateFrom,
    allFilters.leadFollowupDateTo,
    allFilters.leadClosureDateFrom,
    allFilters.leadClosureDateTo,
    allFilters.rawLeadAddDateFrom,
    allFilters.rawLeadAddDateTo,
    allFilters.selOperatorValue,
    allFilters.selectedLeadStage,
    allFilters.selCustomerIntent,
    isBroadcastMode,
  ]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      filter_type:
        activeTab === 1
          ? "todays_follow_ups"
          : activeTab === 2
          ? "missed_followups"
          : allFilters.clickedCard
          ? allFilters.clickedCard
          : "",
    }));
  }, [activeTab, allFilters.clickedCard]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (allFilters.isToggledValue) {
      navigate("/lead-management", { replace: true });
    }
  }, [allFilters.isToggledValue]);

  useEffect(() => {
    setAllFilters((prev) => {
      if (!prev.selectedGym) return prev;

      const filtered = prev.selectedGyms.filter(
        (gym) => gym?.value !== prev.selectedGym?.value
      );

      return {
        ...prev,
        selectedGyms: [prev.selectedGym, ...filtered],
      };
    });
  }, [allFilters.selectedGym]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    }
  }, [exportData]);

  const hasFiltersApplied = useMemo(() => {
    const defaultFilters = {
      selAddedby: "",
      selLeadStatus: "",
      selCustomerIntent: "",
      selFollowupStatus: "",
      selLeadSource: "",
      selUTMSource: "",
      selectedVendor: "",
      selCard: "",
      setPlan: "",
      selIsRaw: "",
      selLeadFrom: "",
      selFollowupStage: "",
      selOperatorValue: "",
      clickedCard: "",
      selectedWhatsappVerification: "",
      selectedLeadStage: "",
      selectedAssigneeStatus: "",
      searchString: "",
      leadAddDateFrom: "",
      leadAddDateTo: "",
      leadFollowupDateFrom: "",
      leadFollowupDateTo: "",
      leadClosureDateFrom: "",
      leadClosureDateTo: "",
      leadConvertedDateFrom: "",
      leadConvertedDateTo: "",
      rawLeadAddDateFrom: "",
      rawLeadAddDateTo: "",
    };

    const hasArrayFilters =
      allFilters.selFollowupTime?.length > 0 ||
      allFilters.selConvertedIn?.length > 0;

    const hasToggleFilter = allFilters.isToggledValue !== false;

    const hasGymFilter =
      allFilters.selectedGym &&
      (!isAdmin && !isMarketing && !isManagerRole
        ? allFilters.selectedGym.value !==
          (userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "")
        : true);

    const hasAssigneeFilter =
      allFilters.selAssignee &&
      (!isAdmin && !isMarketing && !isManagerRole
        ? allFilters.selAssignee.value !==
          (userInfoData?.uid || userInfoData?.user_id || "")
        : true);

    const hasStringFilters = Object.keys(defaultFilters).some(
      (key) => allFilters[key] !== defaultFilters[key]
    );

    return (
      hasStringFilters ||
      hasArrayFilters ||
      hasToggleFilter ||
      hasGymFilter ||
      hasAssigneeFilter
    );
  }, [allFilters]);

  return (
    <div className="w-100 h-auto position-relative">
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "view"
              ? "mod-height-95vh mod-width-70p"
              : modValues.modName === "edit" ||
                modValues.modName === "followup" ||
                modValues.modName === "re-assign"
              ? "mod-width-50p"
              : modValues.modName === "add"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "broadcast_data"
              ? "mod-height-95vh broadcast-modal"
              : modValues.modName === "send-payment-link" ||
                modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          }`}
        >
          {modValues.modName !== "followup" &&
          modValues.modName !== "edit" &&
          modValues.modName !== "re-assign" &&
          modValues.modName !== "add" &&
          modValues.modName !== "send-payment-link" &&
          modValues.modName !== "click-to-call" ? (
            <ModalHeadAndClose
              title={`${
                modValues.modName === "add"
                  ? "Add New Lead"
                  : modValues.modName === "view" ||
                    modValues.modName === "followup"
                  ? `Lead Details - ${modValues.rowData?.name || ""}`
                  : modValues.modName === "exportModal"
                  ? "Select Fields To Export"
                  : modValues.modName === "broadcast_data"
                  ? "Broadcast Message"
                  : modValues.modName?.replace(/_/g, " ")
              }`}
              onClose={onCloseModal}
            />
          ) : null}

          {modValues.modName === "add" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={() => getComineReload(filters)}
            />
          ) : modValues.modName === "view" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "edit" ? (
            <LeadEditForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={() => getComineReload(filters)}
              isEdit={true}
              rowData={modValues.rowData}
              cardName={modValues.modName}
            />
          ) : modValues.modName === "followup" ? (
            <FollowInfoFormV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              followupStage={modValues.rowData?.follow_up_number || 0}
              callFunction={() => getComineReload(filters)}
              allFollowups={
                modValues.rowData?.follow_ups ||
                modValues.rowData?.followup_details ||
                []
              }
              closeModal={onCloseModal}
            />
          ) : modValues.modName === "re-assign" ? (
            <AssignForm
              userInfoData={userInfoData}
              selectedRows={modValues.selectedRows}
              closeModal={() => {
                onCloseModal();
              }}
            />
          ) : modValues.modName === "broadcast_data" ? (
            <>
              {isFilterSegmentShown && (
                <CmnFilters
                  from="lead-management"
                  isSegment={true}
                  userInfoData={userInfoData}
                  onClickReset={onResetFilters}
                  filters={allFilters}
                  setFilters={setAllFilters}
                />
              )}

              <CommonBroadForm
                from="lms"
                filters={filters}
                allFilters={allFilters}
                userInfoData={userInfoData}
                closeModal={onCloseModal}
                setIsFilterSegmentShown={setIsFilterSegmentShown}
              />
            </>
          ) : modValues.modName === "exportModal" ? (
            <div>
              <SelectExportables
                name="leads"
                exportableData={leadExportableData}
                filters={filters}
                callFunction={onClickExport}
                isLoadingCSV={exportLoading}
                csvData={csvData}
                setCsvData={setCsvData}
              />
            </div>
          ) : modValues.modName === "send-payment-link" ? (
            <LMSPMLink
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              rowData={modValues.rowData}
              callFunction={() => getComineReload(filters)}
            />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "total_outgoing_call" ||
            modValues.modName === "total_outgoing_connected_call" ? (
            <CallDetail
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              filterType={modValues.modName}
            />
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <PageHeadingNew
            heading="Lead Management"
            subheading="Lead Management & Performance Overview"
            buttonLabel={isMarketing ? false : "Add New Lead"}
            onButtonClick={
              isMarketing
                ? null
                : () =>
                    setModValues({
                      isModOpen: true,
                      modName: "add",
                    })
            }
            onReload={() => getComineReload(filters)}
            showFilters={showFilters}
            setShowFilters={setShowFilters}
            hasFiltersApplied={hasFiltersApplied}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          {showFilters && (
            <CmnFilters
              from="lead-management"
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              onClickExportBtn={() =>
                setModValues({
                  isModOpen: true,
                  modName: "exportModal",
                })
              }
              onClickBroadcastBtn={
                isBroadcastCreateAllowed
                  ? () =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "broadcast_data",
                      }))
                  : null
              }
              // setActiveCardIndex={setActiveCardIndex}
            />
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          <LMSStatCards
            onCardClick={handleStatCardClick}
            activeKey={allFilters.clickedCard}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <LMSTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            userInfoData={userInfoData}
            callFunction={() => getComineReload(filters)}
            tabsRef={tabsRef}
          />
        </Col>
      </Row>
    </div>
  );
};

export default LMSStructure;
